import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { useTheme } from "@mui/material/";

export const ZohoCTAButton = ({ children, loading, ...rest }) => {
  const theme = useTheme();
  return (
    <Button
      variant="contained"
      size="small"
      sx={{
        bgcolor: theme.palette.primary.main,
        boxShadow: `inset 0 -3px 4px  ${theme.palette.primary.main}`,
        fontSize: "medium",
        fontWeight: "bold",
        textTransform: "capitalize",
        backgroundImage: `transparent linear-gradient(0deg, ${theme.palette.primary.main} 0%,  ${theme.palette.primary.light} 100%)`,
        py: 0.3,
        px: "10px",
        "&:hover": {
          backgroundImage: `linear-gradient(to top,${theme.palette.primary.dark}, ${theme.palette.primary.light})`,
          bgcolor: theme.palette.primary.main,
          boxShadow: "none",
        },
        position: "relative",
      }}
      {...rest}
    >
      {loading ? (
        <Box
          component="span"
          sx={{
            position: "absolute",
            inset: 0,
            display: "grid",
            placeItems: "center",
          }}
        >
          <CircularProgress size={17} />
        </Box>
      ) : null}
      {children}
    </Button>
  );
};
